import React, { useState } from "react";
import { useEffect } from "react";
import no_data_found from "src/assets/images/no_data_found.png";

export default function RecordNotFound({ title }) {
  const [delayTime, setDelayTime] = useState(false);

  useEffect(() => {
    setTimeout(() => setDelayTime(true), 1000);
  }, []);

  return (
    <>
      {delayTime && (
        <div className="no-access-string">
          <img className="mx-auto" src={no_data_found} />
          <p className="mt-3">{title} Not Found</p>
        </div>
      )}
    </>
  );
}
